import { useEffect } from "react";
import { useLocation } from "react-router";
import { useNavEntryId } from "@/hooks/useBackNav";
import { hasReturnAnchor } from "@/lib/nav/returnAnchor";

/**
 * ルート変更時にスクロールを一番上に戻すコンポーネント。
 * 一覧から詳細を開いて戻ってきたとき（送る先を覚えている枠）は上へ送らない。
 * その画面が開いた行まで送るため（`lib/nav/returnAnchor.ts`・PRODUCT_DEV-1205）
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const entryId = useNavEntryId();
  // 描く途中で見る（effect は子が先に走り、戻った先の一覧が送る先を消したあとになるため）
  const returning = hasReturnAnchor(entryId);

  useEffect(() => {
    if (returning) return;
    window.scrollTo({ top: 0, behavior: "smooth" });
    // 枠が変わっただけ（同じ画面の中の絞り込みなど）では送らない。これまでどおり画面が変わったときだけ
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};
